export const FONTS = {
  celosia: 'SfUiText',
  daffodil: 'SfUiText',
  carnation: 'Lato',
  calathea: 'Quicksand',
  lilac: 'SfUiText'
};
